<template>
	<div :class="classes" :is-pro="isPro">
		<div class="post-smtp-card-content-wrapper">
			<div class="post-smtp-image-container" style="margin-right: 15px;">
				<slot name="image"></slot>
			</div>
			<div>
				<div class="post-smtp-count-wrapper" :style="'margin-bottom: ' + ( 'opened--pro' === type ? '5px' : '8.36px' ) + ';'">
					<h2 class="post-smtp-count">
						<slot name="count"></slot>
					</h2>
				</div>
				<div>
					<p class="post-smtp-content">
						<slot name="content"></slot>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PostSmtpCard',

	props: {
		type: {
			type: String,
			required: true,
		},

		isPro: {
			type: Boolean,
			default: false,
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
	} ),

	computed: {
		classes() {
			return {
				'post-smtp-card': true,
				'post-smtp-card-all': this.type === 'all',
				'post-smtp-card-success': this.type === 'success',
				'post-smtp-card-failed': this.type === 'failed',
				'post-smtp-card-opened--pro': this.type === 'opened--pro',

				'post-smtp-card-pro': this.isPro,
			};
		},
	}
}
</script>

<style scoped>
.post-smtp-card {
	width: calc( 25% - 16px + 2px );
	height: 140px;
	border-radius: 4px;
	float: left;
	margin-right: 16px;
}

.post-smtp-card:last-child {
	margin-right: 0;
}

.post-smtp-card-all {
	background: #EDF4FF;
	border: 1px solid #D3DDEB;
}

.post-smtp-card-success {
	background: #EDFFEF;
	border: 1px solid #D3EBD6;
}

.post-smtp-card-failed {
	background: #FFEDED;
	border: 1px solid #EBD3D3;
}

.post-smtp-card-opened--pro {
	background: url( ../images/fa-solid_crown.svg ), radial-gradient(95.39% 99.9% at 49.79% 0%, #FFD291 0%, #F9AA39 100%);
	border: 1px solid #EBE1D3;
	background-repeat: no-repeat;
	background-position: 275px 10px, center;
}

.post-smtp-card-content-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;

	width: 100%;
	height: 100%;
}

.post-smtp-image-container {
	margin-right: 15px;

	width: 42px;
	height: 42px;

	display: flex;
	justify-content: center;
	align-items: center;

	border-radius: 50%;
}

.post-smtp-card-all .post-smtp-image-container {
	background: url( '../images/total-emails.png' );
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.post-smtp-card-success .post-smtp-image-container {
	background: url( '../images/successfull-emails.png' );
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.post-smtp-card-failed .post-smtp-image-container {
	background: url( '../images/failed-emails.png' );
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.post-smtp-card-opened--pro .post-smtp-image-container {
	background: url( '../images/opened-emails.png' );
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.post-smtp-card-pro.post-smtp-card-all .post-smtp-image-container {
	background: url( '../images/pro-total-emails.png.png' );
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.post-smtp-card-pro.post-smtp-card-success .post-smtp-image-container {
	background: url( '../images/pro-successfull-emails.png' );
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.post-smtp-card-pro.post-smtp-card-failed .post-smtp-image-container {
	background: url( '../images/pro-failed-emails.png' );
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}

.post-smtp-count {
	color: #231F20;
	font-family: Poppins;
	font-size: 20px;
	font-style: normal;
	font-weight: 600;
	line-height: 20px; /* 100% */
}

.post-smtp-content {
	color: #231F20;
	font-family: Poppins;
	font-size: 11px;
	font-style: normal;
	font-weight: 500;
	line-height: 13px; /* 118.182% */
}

.post-smtp-card-pro .post-smtp-count,
.post-smtp-card-pro .post-smtp-content {
	color: #fff;
}

.post-smtp-card-pro.post-smtp-card-all {
	background: #6291D9;
}

.post-smtp-card-pro.post-smtp-card-success {
	background: #74B27B;
}

.post-smtp-card-pro.post-smtp-card-failed {
	background: #E57373;
}

.post-smtp-card-pro.post-smtp-card-opened--pro {
	background: radial-gradient(95.39% 99.9% at 49.79% 0%, #FFD291 0%, #F9AA39 100%);
}
</style>